import Button from '@ui/buttons/button/button';
import SlideDownCard from '@ui/cards/slide-down-card/slide-down-card';
import Container from '@ui/container/container';
import Text from '@ui/text/text/text';
import { ICONS } from '@ui/icons/types';
import { memo, useState } from 'react';
import Icon from '@ui/icons/icon';
import classes from '../campaign-editor.module.css';

interface Props {
  backgroundColor: string;
  containerColor: string;
  accentColor: string;
  secondaryAccentColor: string;
  secondaryBackgroundColor: string;
  headingTextColor: string;
  bodyTextColor: string;
  buttonTextColor: string;

  setBackgroundColor: (str: string) => void;
  setContainerColor: (str: string) => void;
  setAccentColor: (str: string) => void;
  setSecondaryAccentColor: (str: string) => void;
  setSecondaryBackgroundColor: (str: string) => void;
  setHeadingTextColor: (str: string) => void;
  setBodyTextColor: (str: string) => void;
  setButtonTextColor: (str: string) => void;
}

function ColorInputs({
  backgroundColor,
  setBackgroundColor,
  containerColor,
  setContainerColor,
  accentColor,
  setAccentColor,
  secondaryAccentColor,
  setSecondaryAccentColor,
  secondaryBackgroundColor,
  setSecondaryBackgroundColor,
  headingTextColor,
  setHeadingTextColor,
  bodyTextColor,
  setBodyTextColor,
  buttonTextColor,
  setButtonTextColor,
}: Props) {
  const [colorsOpen, setColorsOpen] = useState(true);

  return (
    <Container padding="0 12px">
      <Container
        style={{ transition: 'border-radius 350ms' }}
        borderRadius={colorsOpen ? '16px' : '12px'}
        design="GlobalCont2"
      >
        <Container>
          <Button
            className="flex jc-space-between ai-center width-100-percent"
            onClick={() => setColorsOpen((prev) => !prev)}
          >
            <Text className="H6" design="GlobalIcoText1">
              Colors
            </Text>
            <div style={{ transform: colorsOpen ? `rotate(90deg)` : undefined }}>
              <Icon name={ICONS.ANGLE_RIGHT} size={12} />
            </div>
          </Button>
        </Container>
        <SlideDownCard autoGrow open={colorsOpen} animateOnInitialLoad={false}>
          <Container padding="0 0 8px 0">
            <div className={classes.colorFieldRow}>
              <label className={classes.fieldLabel}>Background</label>
              <div className={classes.colorField}>
                <input
                  type="color"
                  className={classes.colorSwatch}
                  value={backgroundColor}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => setBackgroundColor(e.target.value)}
                />
                <span className={classes.colorHex}>{backgroundColor.toUpperCase()}</span>
              </div>
            </div>
            <div className={classes.colorFieldRow}>
              <label className={classes.fieldLabel}>Container</label>
              <div className={classes.colorField}>
                <input
                  type="color"
                  className={classes.colorSwatch}
                  value={containerColor}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => setContainerColor(e.target.value)}
                />
                <span className={classes.colorHex}>{containerColor.toUpperCase()}</span>
              </div>
            </div>
            <div className={classes.colorFieldRow}>
              <label className={classes.fieldLabel}>Secondary Background</label>
              <div className={classes.colorField}>
                <input
                  type="color"
                  className={classes.colorSwatch}
                  value={secondaryBackgroundColor}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSecondaryBackgroundColor(e.target.value)}
                />
                <span className={classes.colorHex}>{secondaryBackgroundColor.toUpperCase()}</span>
              </div>
            </div>
            <div className={classes.colorFieldRow}>
              <label className={classes.fieldLabel}>Heading Text Color</label>
              <div className={classes.colorField}>
                <input
                  type="color"
                  className={classes.colorSwatch}
                  value={headingTextColor}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => setHeadingTextColor(e.target.value)}
                />
                <span className={classes.colorHex}>{headingTextColor.toUpperCase()}</span>
              </div>
            </div>
            <div className={classes.colorFieldRow}>
              <label className={classes.fieldLabel}>Body Text Color</label>
              <div className={classes.colorField}>
                <input
                  type="color"
                  className={classes.colorSwatch}
                  value={bodyTextColor}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => setBodyTextColor(e.target.value)}
                />
                <span className={classes.colorHex}>{bodyTextColor.toUpperCase()}</span>
              </div>
            </div>
            <div className={classes.colorFieldRow}>
              <label className={classes.fieldLabel}>Accent Color</label>
              <div className={classes.colorField}>
                <input
                  type="color"
                  className={classes.colorSwatch}
                  value={accentColor}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => setAccentColor(e.target.value)}
                />
                <span className={classes.colorHex}>{accentColor.toUpperCase()}</span>
              </div>
            </div>
            <div className={classes.colorFieldRow}>
              <label className={classes.fieldLabel}>Secondary Accent Color</label>
              <div className={classes.colorField}>
                <input
                  type="color"
                  className={classes.colorSwatch}
                  value={secondaryAccentColor}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSecondaryAccentColor(e.target.value)}
                />
                <span className={classes.colorHex}>{secondaryAccentColor.toUpperCase()}</span>
              </div>
            </div>
            <div className={classes.colorFieldRow}>
              <label className={classes.fieldLabel}>Button Text Color</label>
              <div className={classes.colorField}>
                <input
                  type="color"
                  className={classes.colorSwatch}
                  value={buttonTextColor}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => setButtonTextColor(e.target.value)}
                />
                <span className={classes.colorHex}>{buttonTextColor.toUpperCase()}</span>
              </div>
            </div>
          </Container>
        </SlideDownCard>
      </Container>
    </Container>
  );
}

export default memo(ColorInputs);
